// @ts-strict-ignore
import { ConnectionAreaUsageVO, MetaElementUsageIdentityVO } from '@shared/vo/meta-element.vo';
import { Matrix4 } from 'three';
import { AdvancedLine } from '@3d-scene/model/advanced-line';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { Connection } from '@3d-scene/model3d/connection';
import { LineComponentUtils } from '@3d-scene/model3d/util/line-component-utils';

export class RangeOnLineConnectionInfo {
  private _identity: MetaElementUsageIdentityVO;
  private _acceptingTransform: Matrix4;
  private _acceptingAreaUsage: ConnectionAreaUsageVO;
  private _acceptingConnection: Connection;
  private _excludedArticleGUIDs: string[];
  private _freeLines: AdvancedLine[] = null;
  private _baseLine: AdvancedLine = null;

  constructor(private containerService: ContainerService,
              private lineComponentUtils: LineComponentUtils,
              acceptingIdentity: MetaElementUsageIdentityVO, excludedArticleGUIDs: string[] = null) {
    const acceptingContainer: ArticleContainer = this.containerService.findArticleContainerInGlobal(acceptingIdentity.articleUsageId);
    if (acceptingContainer == null) {
      throw new Error("Can not create RangeOnLineConnectionInfo");
    }
    this._identity = acceptingIdentity;
    this._acceptingTransform = acceptingContainer.matrix.clone();
    this._acceptingAreaUsage = acceptingContainer.findMetaElementUsageByName(acceptingIdentity.metaElementName) as ConnectionAreaUsageVO;
    this._acceptingConnection = acceptingContainer.findConnectionByName(acceptingIdentity.metaElementName);
    this._excludedArticleGUIDs = excludedArticleGUIDs;
  }

  public get identity(): MetaElementUsageIdentityVO {
    return this._identity;
  }

  public get acceptingTransform(): Matrix4 {
    return this._acceptingTransform;
  }

  public get acceptingAreaUsage(): ConnectionAreaUsageVO {
    return this._acceptingAreaUsage;
  }

  public get acceptingConnection(): Connection {
    return this._acceptingConnection;
  }

  public get excludedArticleGUIDs(): string[] {
    return this._excludedArticleGUIDs;
  }

  public get baseLine(): AdvancedLine {
    if (!this._baseLine) {
      this._baseLine = this.containerService.calculateBaseLine(this.acceptingConnection, this.acceptingTransform, true);
    }
    return this._baseLine;
  }

  public get freeLines(): AdvancedLine[] {
    if (!this._freeLines) {
      this._freeLines = this.lineComponentUtils.splitRangeOnLineConnectionInLines(
        this.acceptingAreaUsage,
        this.acceptingConnection,
        this.acceptingTransform,
        this.excludedArticleGUIDs,
        true,
        true
      );
    }
    return this._freeLines;
  }

  public getArticleLine(articleContainer: ArticleContainer): AdvancedLine {
    return this.lineComponentUtils.getArticleLine(articleContainer, this.acceptingAreaUsage, this.baseLine);
  }

  public findFreeLineByArticleLine(articleLine: AdvancedLine): AdvancedLine {
    if (!articleLine) {
      return null;
    }
    for (const line of this.freeLines) {
      if (line.hasInnerOverlappedLine(articleLine)) {
        return line;
      }
    }
    return null;
  }
}
